window.okeReviewsWidgetOnInit = function() {
  var reviewSummaryElements = document.querySelectorAll('.js-okeReviews-reviewsSummary');
  var reviewTabElement = document.querySelector('div[data-tab-header="reviews"]');
  
  if (reviewTabElement && reviewSummaryElements.length) {
    reviewSummaryElements.forEach(function(reviewSummaryElement) {
      reviewSummaryElement.addEventListener('click', function() {
      	reviewTabElement.click();
      });
    });
  }
}